import { memo, useState } from "react";
import { IconButton, Popover, ToggleButtonGroup, ToggleButton } from "@mui/material";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import CheckIcon from "@mui/icons-material/Check";
import {
  red,
  pink,
  purple,
  blue,
  cyan,
  teal,
  lightGreen,
  lime,
  yellow,
  amber,
  deepPurple,
  orange,
  deepOrange,
  indigo,
  grey,
  green,
  blueGrey,
} from "@mui/material/colors";

const ColorPicker = ({ selectedColor, handleColorChange }) => {
  const [colorAnchorEl, setColorAnchorEl] = useState(null);

  const availableColors = [
    grey[200],
    indigo[200],
    deepPurple[200],
    amber[200],
    orange[200],
    pink[200],
    deepOrange[200],
    green[200],
    red[200],
    lightGreen[200],
    purple[200],
    lime[200],
    yellow[200],
    cyan[200],
    teal[200],
    blue[200],
    blueGrey[200],
    "#ffffff",
  ];

  return (
    <>
      <IconButton
        onClick={(e) => setColorAnchorEl(e.currentTarget)}
        sx={{
          width: 40,
          height: 40,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          bgcolor: "transparent",
          flexShrink: 0,
          position: "relative",
          "&:hover": {
            bgcolor: "action.hover",
          },
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "4px",
            bgcolor: selectedColor,
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
          },
        }}
      >
        <PaletteOutlinedIcon sx={{ fontSize: 20, color: "text.primary" }} />
      </IconButton>

      <Popover
        open={Boolean(colorAnchorEl)}
        anchorEl={colorAnchorEl}
        onClose={() => setColorAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: { p: 2, mt: 1 },
          },
        }}
      >
        <ToggleButtonGroup
          value={selectedColor}
          exclusive
          onChange={(e, newColor) => {
            if (newColor !== null) {
              handleColorChange(newColor);
              setColorAnchorEl(null);
            }
          }}
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 1,
            width: 220,
          }}
        >
          {availableColors.map((color) => (
            <ToggleButton
              key={color}
              value={color}
              sx={{
                width: 32,
                height: 32,
                minWidth: 32,
                maxWidth: 32,
                padding: 0,
                border: "1px solid !important",
                borderColor: `${grey[400]} !important`,
                borderRadius: "50% !important",
                bgcolor: color,
                overflow: "hidden",
                "&:hover": {
                  bgcolor: color,
                  opacity: 0.9,
                  transform: "scale(1.05)",
                },
                "&.Mui-selected": {
                  bgcolor: color,
                  borderRadius: "50% !important",
                  "&:hover": {
                    bgcolor: color,
                    opacity: 0.9,
                  },
                },
              }}
            >
              {selectedColor === color && (
                <CheckIcon />
              )}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Popover>
    </>
  );
};

export default memo(ColorPicker);

